export default {
  /**
   * All data that need to be changed before go to view
   */
};
